import {
  laptopMediumMax,
  largeTabletMax,
  mobileXLargeMax,
  mobileXXLargeMax,
} from '@propertypal/shared/src/constants/mediaQueries';
import { Container as SelectInput } from '@propertypal/web-ui/src/inputs/SelectInput.style';
import { MAX_WIDTH } from '@propertypal/web-ui/src/layout/PageWrapper.style';
import styled from 'styled-components';
import { filterBreakpoint } from './SearchBar/SearchBar.style';

export const SearchTitleWrapper = styled.div`
  padding: 30px 20px 0;

  @media (${laptopMediumMax}) {
    padding: 15px 15px 0;
  }
`;

export const ListSearchTitleWrapper = styled.div`
  @media (${mobileXXLargeMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;

  @media (${laptopMediumMax}) {
    flex-direction: column;
  }
`;

export const InfoContent = styled.div`
  max-width: ${MAX_WIDTH}px;
  display: flex;
  flex-direction: column;

  & > div {
    margin-top: 15px;
  }
`;

export const Title = styled.h1`
  font-size: 36px;
  margin-left: -2px;
  color: ${(props) => props.theme.textDark};

  @media (${mobileXLargeMax}) {
    font-size: 28px;
  }
`;

export const SideOptions = styled.div`
  display: flex;
  flex-direction: row;

  @media (${largeTabletMax}) {
    margin-top: 15px;

    ${SelectInput} {
      max-width: 200px;
    }
  }

  @media (${filterBreakpoint}) {
    ${SelectInput} {
      width: 100%;
      max-width: none;
    }
  }
`;

export const SaveSearchWrapper = styled.div`
  min-width: 200px;
  margin-right: 20px;

  @media (${filterBreakpoint}) {
    display: none;
  }
`;
